<p-menu #menu [model]="_items" [popup]="true" (onShow)="onShowMenu()" (onHide)="onHideMenu()"></p-menu>
<k-button [label]="label" size="xs" buttonStyle="gradient" iconPosition="right" [faIcon]="['fas',icon]"
    (click)="menu.toggle($event)"> </k-button>